import React from "react";

import { useTranslation } from "react-i18next";

const SportsContext = React.createContext();

function exploreReducer(state, action) {
  switch (action.type) {
    case "setDate": {
      return {
        ...state,
        fromDate: action.value.startDateOfDay,
        toDate: action.value.endDateOfDay,
        index: action.value.index,
        isLoading: true,
      };
    }

    case "resetDate": {
      const startDateInit = new Date();
      startDateInit.setHours(0, 0, 1);
      const endDateInit = new Date();
      endDateInit.setHours(23, 59, 59);
      return {
        ...state,
        fromDate: startDateInit,
        toDate: endDateInit,
        index: 7,
      };
    }

    case "setLeagues": {
      return {
        ...state,
        leagues: action.value,
      };
    }
    case "setCountries": {
      return {
        ...state,
        countries: action.value,
      };
    }
    case "setTeams": {
      return {
        ...state,
        teams: action.value,
      };
    }

    case "setIsLoading": {
      return {
        ...state,
        isLoading: action.value,
      };
    }

    case "setSearchIsActive": {
      return {
        ...state,
        activeSearch: action.events.length ? true : false,
        searchEvents: action.events,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function SportsProvider({ children }) {
  const { t, i18n } = useTranslation();

  const startDateInit = new Date();
  startDateInit.setHours(0, 0, 1);
  const endDateInit = new Date();
  endDateInit.setHours(23, 59, 59);

  const [state, dispatch] = React.useReducer(exploreReducer, {
    fromDate: startDateInit,
    toDate: endDateInit,
    index: 7,
    leagues: [],
    countries: [],
    teams: [],
    isLoading: true,
    activeSearch: false,
    searchEvents: [],
  });

  const value = { state, dispatch };
  return (
    <SportsContext.Provider value={value}>{children}</SportsContext.Provider>
  );
}

function useSports() {
  const context = React.useContext(SportsContext);
  if (context === undefined) {
    throw new Error("Sports must be used within a EventProvider");
  }
  return context;
}

export { SportsProvider, useSports };
